var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("sui-button",_vm._g({tag:"button",class:[
		_vm.$style.button,
		_vm.$style[_vm.styleButton],
		_vm.loading ? 'loading' : '',
		_vm.styleClass
	],attrs:{"disabled":_vm.loading || _vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }